module.exports = __webpack_public_path__ + "static/city_certify@2x-21a7c391a5c6a3f0a96a6c6f84baa09f.png";